export default {
  STATUS_CHANGE: 'CONNECTION_STATUS_CHANGE',
  SOCKET: {
    CONNECTED: 'WEBSOCKET_CONNECTED',
    CONNECTING: 'WEBSOCKET_CONNECTING',
    DISCONNECTED: 'WEBSOCKET_DISCONNECTED'
  }
}
